import { Filter } from "./types.js";

export type SerializedFilters = Record<string, unknown>;

export function serializeIdSelection(
    values: ReadonlyMap<unknown, unknown> | ReadonlySet<unknown>,
): string[] {
    const ids = [ ...values.keys() ];

    if (!ids.every((id): id is string => typeof id === "string"))
        throw new TypeError("Entity IDs must be serialized from strings.");

    return ids;
}

function findFilter(filters: Filter[], name: string): Filter {
    const filter = filters.find((entry) => entry.name === name);

    if (!filter)
        throw new Error(`Unable to find filter "${name}"`);

    return filter;
}

export function serializeFilterValues(filters: Filter[], values: Map<string, unknown>): SerializedFilters {
    const entries = [ ...values.entries() ].map(([ name, value ]) => {
        const filter = findFilter(filters, name);

        return [
            name,
            filter.serialize(value as never),
        ];
    });

    return Object.fromEntries(entries);
}

export async function unserializeFilterValues(filters: Filter[], values: SerializedFilters): Promise<Map<string, unknown>> {
    const promisesEntries = Object.entries(values).map(async ([ name, value ]) => {
        const filter = findFilter(filters, name);

        return [
            name,
            await filter.unserialize(value),
        ] as const;
    });
    const entries = await Promise.all(promisesEntries);

    return new Map(entries);
}
